v-text-field<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("mcg.add") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-start pt-3>
            <v-flex xs11 lg7 pa-3>
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("mcg.addinfor") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pa-6>
                    <v-flex xs11 lg11>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("mcg.row2") }}</b> <br />
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="GroupName"
                        :label="$t('mcg.spegroupname')"
                        :rules="[(v) => !!v || $t('mcg.spegroupname2')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs11 lg11>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("dashboard.policy") }} </b>
                      <span class="grey--text">{{ $t("mcg.policy1") }}</span>
                    </v-flex>
                    <!-- Policy -->
                    <v-flex xs11 lg11>
                      <v-autocomplete
                        return-object
                        item-text="Title"
                        item-value="PolicyId"
                        :items="ItemPolicy"
                        v-model="SelectPolicy"
                        deletable-chips
                        color="info"
                        outlined
                        dense
                        chips
                        small-chips
                        :label="$t('mcg.policy2')"
                        :rules="[(v) => !!v || $t('mcg.policy3')]"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs11 lg11>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("consentform.exdate") }}</b>
                      <br />
                      <v-text-field
                        color="#077893"
                        :label="$t('consentlist.expiration')"
                        :oninput="rulesObject.numRegex"
                        v-model="ExpirationDate"
                        maxlength="2"
                        onkeyup="if(this.value > 10) this.value = 10;"
                        :rules="[(v) => !!v || $t('consentform.exdate2')]"
                        outlined
                        dense
                        clearable
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 lg11>
                      <v-row>
                        <v-col cols="12" md="12">
                          <b class="red--text mr-1">*</b>
                          <b v-if="$t('default') === 'th'"
                            >ข้อมูลที่ต้องการขอ
                          </b>
                          <b v-else>Personal Data to Request </b>
                          <v-combobox
                            color="#077893"
                            v-model="addRequest"
                            :items="itemsRequest"
                            required
                            persistent-hint
                            append-icon=""
                            hide-selected
                            multiple
                            outlined
                            dense
                            clearable
                            small-chips
                            deletable-chips
                            :rules="[required]"
                          >
                          </v-combobox>
                        </v-col>
                      </v-row>
                    </v-flex>
                    <!-- example Consent-->
                    <v-flex xs11 lg11 pt-4>
                      <v-card outlined>
                        <v-card-text>
                          <b style="text-decoration: underline">{{
                            $t("mcg.example")
                          }}</b>
                          <div
                            v-for="(item, index) in ItemsData"
                            :key="index"
                            style="display: inline"
                          >
                            <span class="black--text pl-3 FontSize">
                              {{ item.Text }}
                            </span>
                          </div>
                          <draggable
                            :list="ItemsData"
                            :disabled="!Enabled"
                            class="list-group move"
                            ghost-class="ghost"
                            :move="Fn_CheckMove"
                            @start="Dragging = true"
                            @end="Dragging = false"
                          >
                            <div
                              class="list-group-item"
                              v-for="(item, index) in ItemsData"
                              :key="index + 1"
                            >
                              <v-card color="#ddf7ff" class="elevation-0 ma-3">
                                <v-card-text>
                                  <v-layout row wrap align-center>
                                    <v-flex xs10 lg10 text-left>
                                      <b> {{ item.Text }}</b>
                                    </v-flex>
                                    <v-flex xs2 lg2>
                                      <v-btn
                                        color="red"
                                        fab
                                        small
                                        dark
                                        depressed
                                        @click="Fn_Delete(index)"
                                      >
                                        <v-icon>mdi-delete-outline</v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </div>
                          </draggable>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout row wrap justify-center align-center pt-1 pa-2 pb-4>
                    <v-flex xs3 sm3 md3 lg3>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        @click="Fn_CreatePolicy"
                        :loading="loading"
                        >{{ $t("policy.text10") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs11 lg4 pa-3>
              <v-card class="rounded-lg">
                <v-card-text>
                  <!-- <b class="red--text mr-1">*</b> -->
                  <b>{{ $t("Toolbar.consent") }} </b>
                  <span class="grey--text ml-2"> {{ $t("mcg.consent1") }}</span>
                </v-card-text>
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg11>
                      <v-textarea
                        color="#077893"
                        outlined
                        :label="$t('consentform.brief')"
                        counter="500"
                        v-model="Title"
                      ></v-textarea>
                      <!-- :rules="[
                          (v) => !!v || $t('mcg.consent3'),
                          (v) => v.length <= 500 || $t('consentform.brief3'),
                        ]" -->
                    </v-flex>
                    <v-flex xs11 lg11>
                      <v-autocomplete
                        item-text="HeaderConsent"
                        item-value="ConsentId"
                        :items="ItemConsent"
                        v-model="SelectConsent"
                        outlined
                        dense
                        chips
                        return-object
                        small-chips
                        multiple
                        :label="$t('mcg.consent2')"
                        @change="Fn_AddConsent"
                        :rules="[(v) => !!v || $t('mcg.consent3')]"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { draggable },
  data: function () {
    return {
      valid: true,
      Enabled: true,
      Dragging: false,
      LoadingPolicy: false,
      ItemsData: [],
      ItemsDataSelect: [],
      ItemPolicy: [],
      ItemConsent: [],
      GroupName: "",
      Content: "",
      ConsentId: "",
      GroupDefault: [],
      GroupSelect: [],
      SelectPolicy: "",
      SelectConsent: "",
      DataConsent: [],
      ExpirationDate: "2",
      rulesObject: {
        numRegex: "this.value = this.value.replace(/[^1-9.]|/g, '').substr()",
      },
      Title: "",
      addRequest: [],
      itemsRequest: [],
      addRequestFix: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    draggingInfo() {
      return this.Dragging ? "under drag" : "";
    },
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataPolicy();
    this.Fn_GetDataConsent();
  },
  methods: {
    Fn_CheckMove: function (e) {

    },
    Fn_AddConsent() {
      this.ItemsDataSelect = [];
      this.ItemsData = [];
      var index = 0;
      for (var i in this.SelectConsent) {
        index += 1;
        this.GroupSelect = {
          ConsentId: this.SelectConsent[i].ConsentId,
          Level: index,
          Text: this.SelectConsent[i].HeaderConsent,
        };
        // this.GroupDefault = {
        //   Text: this.SelectConsent[i].HeaderConsent,
        // };
        this.ItemsData.push(this.GroupSelect);
        this.ItemsDataSelect.push(this.GroupDefault);
      }
    },
    Fn_Delete(i) {
      this.ItemsDataSelect.splice(i, 1);
      this.ItemsData.splice(i, 1);
      this.SelectConsent.splice(i, 1);
    },
    async Fn_GetDataPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_CreatePolicy() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var payload = {
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          AccessToken: this.$cookies.get("OneAccessToken"),
          GroupName: this.GroupName,
          PolicyId: this.SelectPolicy.PolicyId,
          Consent: this.ItemsData,
          ExpireIn: this.ExpirationDate,
          Title: this.Title,
          Tag: this.addRequestFix,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "group-consent/InsertDetailGroupConsent",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loading = false;

            if (response.data.Status === "OK") {
              this.ItemPolicy = response.data.Message;
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$router.push("/consent-management-group-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "";
      } else if (value.includes(" ") == true) {
        return "";
      }
      return !!value || "";
    },
    Fn_BackIndex() {
      this.$router.push("/consent-management-group-index");
    },
  },
  watch: {
    ExpirationDate() {
      if (this.ExpirationDate > 10) {
        this.ExpirationDate = 10;
      }
    },
    addRequest(val) {
      this.addRequestFix = val.join(", ");
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.move {
  cursor: move;
}

.FontSize {
  font-size: 14px;
}
</style>
